<template>
  <div class="trip-details-main">
    <div class="content-container">
      <div class="header">
        <div class="title">
          Trip Details for Consignment {{consignmentNo}}
        </div>
      </div>
      <div class="movement-details-container">
        <div v-if="deliveryDetails" class="movement-details-card">
          <div class="header" :style="movementDetailsCardHeaderStyle">
            <div class="label">
              Delivery
            </div>
            <img class="expand-all" src="https://dsmlib.logistics.systems/Icons/Expand.png" alt="Expand All" title="Expand All" @click="deliveryExpandAllBoxContainers">
            <img class="collapse-all" src="https://dsmlib.logistics.systems/Icons/Collapse.png" alt="Collapse All" title="Collapse All" @click="deliveryCollapseAllBoxContainers">
          </div>
          <div class="details-container">
            <div class="details-table-container">
              <table class="details-table">
                <tr>
                  <td class="label">
                    Advised Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{deliveryDetails['Advised Date'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Required Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{deliveryDetails['Required Date'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
              <table class="details-table">
                <tr>
                  <td class="label">
                    Planned For
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{deliveryDetails['Planned For'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Event Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail event-date-detail" :style="{'background-color': deliveryEventDateBackgroundColor}">
                    <strong>{{deliveryDetails['Event Date'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div class="trips-list">
              <div v-for="(trip, index) in deliveryTrips" :key="index" class="trip-container">
                <BoxContainer
                  :isCollapsible="true"
                  :isCollapsed.sync="deliveryTripsBoxContainersCollapsed[trip['Movement']]['mainCollapsed']"
                  :title="trip['Movement']"
                  :ref="trip['Movement']"
                  @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                >
                  <div class="box-container-content">
                    <div class="general-details-container">
                      <table class="general-details">
                        <tr>
                          <td class="label">
                            Driver
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver No'] || trip['Driver Name'] ? `(${trip['Driver No']}) ${trip['Driver Name']}`: '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Driver Tel.
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver Tel'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Driver IC
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver IC'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Prime Mover
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['PM'] || trip['PMNo'] ? `(${trip['PM']}) ${trip['PMNo']}`: '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Trailer
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['TR'] || trip['TRNo'] ? `(${trip['TR']}) ${trip['TRNo']}`: '-'}}</strong>
                          </td>
                        </tr>
                      </table>
                      <table class="general-details">
                        <tr>
                          <td class="label">
                            B2B
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['B2B Consignment No'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label" id="work-ticket-date-label">
                            Work Ticket Date
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>
                              {{
                                trip['Work Ticket Date'] ?
                                new Date(trip['Work Ticket Date']).formatString('yyyy-MM-dd') :
                                '-'
                              }}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Remarks
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Remarks'] || '-'}}</strong>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="trip-statuses-container">
                      <div class="pickup">
                        <BoxContainer
                          :isCollapsible="true"
                          :isCollapsed.sync="deliveryTripsBoxContainersCollapsed[trip['Movement']]['pickupCollapsed']"
                          title="Pickup"
                          :ref="`${trip['Movement']}Pickup`"
                          @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                        >
                          <table class="details-table">
                            <tr>
                              <td class="label">
                                Status
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Status Desc'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Location
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Location'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Area
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Area'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Completed
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Date Completed'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Updated
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Date Updated'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                UserID
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From UserID'] || '-'}}</strong>
                              </td>
                            </tr>
                          </table>
                        </BoxContainer>
                      </div>
                      <div class="dropoff">
                        <BoxContainer
                          :isCollapsible="true"
                          :isCollapsed.sync="deliveryTripsBoxContainersCollapsed[trip['Movement']]['dropoffCollapsed']"
                          title="Dropoff"
                          :ref="`${trip['Movement']}DropOff`"
                          @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                        >
                          <table class="details-table">
                            <tr>
                              <td class="label">
                                Status
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Status Desc'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Location
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Location'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Area
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Area'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                TR Detach
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{!trip['TR Detached'] || trip['TR Detached'] === '0' ? 'No' : 'Yes'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Completed
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Date Completed'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Updated
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Date Updated'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                UserID
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To UserID'] || '-'}}</strong>
                              </td>
                            </tr>
                          </table>
                        </BoxContainer>
                      </div>
                    </div>
                  </div>
                </BoxContainer>
              </div>
            </div>
          </div>
        </div>
        <div v-if="collectionDetails" class="movement-details-card">
          <div class="header" :style="movementDetailsCardHeaderStyle">
            <div class="label">
              Collection
            </div>
            <img class="expand-all" src="https://dsmlib.logistics.systems/Icons/Expand.png" alt="Expand All" title="Expand All" @click="collectionExpandAllBoxContainers">
            <img class="collapse-all" src="https://dsmlib.logistics.systems/Icons/Collapse.png" alt="Collapse All" title="Collapse All" @click="collectionCollapseAllBoxContainers">
          </div>
          <div class="details-container">
            <div class="details-table-container">
              <table class="details-table">
                <tr>
                  <td class="label">
                    Advised Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{collectionDetails['Advised Date'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Required Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{collectionDetails['Required Date'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
              <table class="details-table">
                <tr v-if="showRFCDocReceivedAndRFCRemarks">
                  <td class="label">
                    RFC Doc. Received
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{collectionDetails['RFC Doc. Rec. Date'] || '-'}}</strong>
                  </td>
                </tr>
                <tr v-if="showRFCDocReceivedAndRFCRemarks">
                  <td class="label">
                    RFC Remarks
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{collectionDetails['RFC Remarks'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Event Date
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail event-date-detail" :style="{'background-color': collectionEventDateBackgroundColor}">
                    <strong>{{collectionDetails['Event Date'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div class="trips-list">
              <div v-for="(trip, index) in collectionTrips" :key="index" class="trip-container">
                <BoxContainer
                  :isCollapsible="true"
                  :isCollapsed.sync="collectionTripsBoxContainersCollapsed[trip['Movement']]['mainCollapsed']"
                  :title="trip['Movement']"
                  :ref="trip['Movement']"
                  @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                >
                  <div class="box-container-content">
                    <div class="general-details-container">
                      <table class="general-details">
                        <tr>
                          <td class="label">
                            Driver
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver No'] || trip['Driver Name'] ? `(${trip['Driver No']}) ${trip['Driver Name']}`: '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Driver Tel.
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver Tel'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Driver IC
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Driver IC'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Prime Mover
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['PM'] || trip['PMNo'] ? `(${trip['PM']}) ${trip['PMNo']}`: '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Trailer
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['TR'] || trip['TRNo'] ? `(${trip['TR']}) ${trip['TRNo']}`: '-'}}</strong>
                          </td>
                        </tr>
                      </table>
                      <table class="general-details">
                        <tr>
                          <td class="label">
                            B2B
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['B2B Consignment No'] || '-'}}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Work Ticket Date
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>
                              {{
                                trip['Work Ticket Date'] ?
                                new Date(trip['Work Ticket Date']).formatString('yyyy-MM-dd') :
                                '-'
                              }}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td class="label">
                            Remarks
                          </td>
                          <td class="colon">
                            :
                          </td>
                          <td class="detail">
                            <strong>{{trip['Remarks'] || '-'}}</strong>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="trip-statuses-container">
                      <div class="pickup">
                        <BoxContainer
                          :isCollapsible="true"
                          :isCollapsed.sync="collectionTripsBoxContainersCollapsed[trip['Movement']]['pickupCollapsed']"
                          title="Pickup"
                          :ref="`${trip['Movement']}Pickup`"
                          @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                        >
                          <table class="details-table">
                            <tr>
                              <td class="label">
                                Status
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Status Desc'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Location
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Location'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Area
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Area'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Completed
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Date Completed'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Updated
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From Date Updated'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                UserID
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['From UserID'] || '-'}}</strong>
                              </td>
                            </tr>
                          </table>
                        </BoxContainer>
                      </div>
                      <div class="dropoff">
                        <BoxContainer
                          :isCollapsible="true"
                          :isCollapsed.sync="collectionTripsBoxContainersCollapsed[trip['Movement']]['dropoffCollapsed']"
                          title="Dropoff"
                          :ref="`${trip['Movement']}Dropoff`"
                          @collapseArrowClicked="tripDetailsBoxContainerCollapseArrowClicked($event, trip['Movement'])"
                        >
                          <table class="details-table">
                            <tr>
                              <td class="label">
                                Status
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Status Desc'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Location
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Location'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Area
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Area'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                TR Detach
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{!trip['TR Detached'] || trip['TR Detached'] === '0' ? 'No' : 'Yes'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Completed
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Date Completed'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                Updated
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To Date Updated'] || '-'}}</strong>
                              </td>
                            </tr>
                            <tr>
                              <td class="label">
                                UserID
                              </td>
                              <td class="colon">
                                :
                              </td>
                              <td class="detail">
                                <strong>{{trip['To UserID'] || '-'}}</strong>
                              </td>
                            </tr>
                          </table>
                        </BoxContainer>
                      </div>
                    </div>
                  </div>
                </BoxContainer>
              </div>
            </div>
          </div>
        </div>
        <div v-if="jobCompleteDetails" class="movement-details-card">
          <div class="header" :style="movementDetailsCardHeaderStyle">
            <div class="label">
              Job Complete
            </div>
          </div>
          <div class="details-container">
            <div class="details-table-container">
              <table class="details-table">
                <tr>
                  <td class="label">
                    Driver
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Driver No'] || jobCompleteDetails['JC Driver Name'] ? `(${jobCompleteDetails['JC Driver No']}) ${jobCompleteDetails['JC Driver Name']}`: '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Prime Mover
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC PM'] || jobCompleteDetails['JC PMNo'] ? `(${jobCompleteDetails['JC PM']}) ${jobCompleteDetails['JC PMNo']}`: '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Trailer
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC TR'] || jobCompleteDetails['JC TRNo'] ? `(${jobCompleteDetails['JC TR']}) ${jobCompleteDetails['JC TRNo']}`: '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Location
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Location'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Area
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Area'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
              <table class="details-table">
                <tr>
                  <td class="label">
                    Completed
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Date Completed'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Updated
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Date Updated'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    UserID
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC UserID'] || '-'}}</strong>
                  </td>
                </tr>
                <tr>
                  <td class="label">
                    Remarks
                  </td>
                  <td class="colon">
                    :
                  </td>
                  <td class="detail">
                    <strong>{{jobCompleteDetails['JC Remarks'] || '-'}}</strong>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
    consignmentNo: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return "";
      }

      return this.tripDetails[0]["Consignment No"] || this.tripDetails[1]["Consignment No"];
    },
    movementDetailsCardHeaderStyle: function() {
      if (
        !this.movementDetailsCardHeaderBackgroundColor ||
        this.movementDetailsCardHeaderBackgroundColor === "white" || 
        !this.movementDetailsCardHeaderBackgroundColor.startsWith("#")
      ) {
        return {
          "background-color": "white",
          "color": "black",
        };
      }

      let backgroundColor = this.movementDetailsCardHeaderBackgroundColor.replace("#", "");
      if (backgroundColor.length == 3) { // if there are only 3 hex digits
        backgroundColor = backgroundColor[0] + backgroundColor[0] + backgroundColor[1] + backgroundColor[1] + backgroundColor[2] + backgroundColor[2];
      }

      const red = parseInt(backgroundColor.slice(0, 2), 16); // convert from hex to decimal
      const green = parseInt(backgroundColor.slice(2, 4), 16);
      const blue = parseInt(backgroundColor.slice(4, 6), 16);

      let textColor;
      if (((red + green + blue) / 3) > 100) {
        textColor = 'black';
      } else {
        textColor = 'white';
      }

      return {
        "background-color": this.movementDetailsCardHeaderBackgroundColor,
        "color": textColor,
      };
    },
    deliveryDetails: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return null;
      }

      return this.tripDetails.find((tripDetails) => { // will return undefined if there is are no delivery details
        return tripDetails["Action"] === "DELIVERY"; // there should only be one object in the array that contains delivery details
      });
    },
    deliveryEventDateBackgroundColor: function() {
      if (!this.deliveryDetails['Event Date'] || !this.deliveryDetails['Required Date']) {
        return "transparent";
      }

      const eventDate = new Date(this.deliveryDetails['Event Date']);
      const requiredDate = new Date(this.deliveryDetails['Required Date']);
      if (!eventDate instanceof Date || isNaN(eventDate)) {
        return "transparent";
      }
      if (!requiredDate instanceof Date || isNaN(requiredDate)) {
        return "transparent";
      }

      return eventDate.getTime() <= requiredDate.getTime() ? "#79d279" : "#ff4d4d";
    },
    deliveryTrips: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return []; // return empty array instead of null when no tripDetails are passed,
      } // so that the for loops in the template won't throw an error, because trying to iterate over null will throw an error

      return this.deliveryDetails ? this.deliveryDetails["Trips"] : [];
    },
    collectionDetails: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return null;
      }

      return this.tripDetails.find((tripDetails) => { // will return undefined if there is are no collection details
        return tripDetails["Action"] === "COLLECTION"; // there should only be one object in the array that contains collection details
      });
    },
    collectionEventDateBackgroundColor: function() {
      if (!this.collectionDetails['Event Date'] || !this.collectionDetails['Required Date']) {
        return "transparent";
      }

      const eventDate = new Date(this.collectionDetails['Event Date']);
      const requiredDate = new Date(this.collectionDetails['Required Date']);
      if (!eventDate instanceof Date || isNaN(eventDate)) {
        return "transparent";
      }
      if (!requiredDate instanceof Date || isNaN(requiredDate)) {
        return "transparent";
      }

      return eventDate.getTime() <= requiredDate.getTime() ? "#79d279" : "#ff4d4d";
    },
    collectionTrips: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return []; // return empty array instead of null when no tripDetails are passed,
      } // so that the for loops in the template won't throw an error, because trying to iterate over null will throw an error

      return this.collectionDetails ? this.collectionDetails["Trips"] : [];
    },
    showRFCDocReceivedAndRFCRemarks: function() {
      if (!this.collectionDetails?.['Advised Date']) { // if Advised Date is not returned
        return false; // don't show
      }

      if (!this.deliveryDetails && !this.settingsSystemAllow1WayColJobRFCUpdates) { // if there is no delivery movement for this job type and RFC is disallowed
        return false; // don't show
      }

      return true; // else, show
    },
    jobCompleteDetails: function() {
      if (!this.tripDetails || this.tripDetails.length === 0) {
        return null;
      }

      return this.tripDetails.find((tripDetails) => { // will return undefined if there is are no job complete details
        return tripDetails["Action"] === "JOB COMPLETE"; // there should only be one object in the array that contains job complete details
      });
    },
  },
  data: function() {
    return {
      settingsSystemAllow1WayColJobRFCUpdates: false,
      movementDetailsCardHeaderBackgroundColor: "white",
      deliveryTripsBoxContainersCollapsed: {},
      collectionTripsBoxContainersCollapsed: {},
    };
  },
  props: {
    tripDetails: { type: Array, default: function() { return null; }, }, // trip details to show
    // expected format for tripDetails:
    // obtainable from API endpoint: Service6G.svc/GetQuickFindMovementDetails
    // [
    //   {
    //     "Consignment No": "HE0000233-001",
    //     "Action": "DELIVERY",
    //     "Advised Date": "2023-04-13 14:02",
    //     "Required Date": "2023-08-31 14:01",
    //     "Planned For": null,
    //     "Plan Remarks": null,
    //     "Event Date": "2023-05-17 14:49",
    //     "Trips": [
    //       {
    //         "JIAction": "D",
    //         "JINo": "JI230000134",
    //         "Consignment No": "HE0000233-001",
    //         "JourneyGUID": "cfffc7fc-6ab3-4b3b-87c5-53a048cea5eb",
    //         "Movement": "DSS",
    //         "Driver No": "839",
    //         "Driver Name": "DSM003",
    //         "Driver Tel": "",
    //         "Driver IC": "111114-00-0000",
    //         "PM": "A001",
    //         "PMNo": "AAA0001",
    //         "TR": "AT01",
    //         "TRNo": "A/TL01",
    //         "B2B Consignment No": null,
    //         "B2B JourneyGUID": null,
    //         "Work Ticket Date": "2023-05-17 00:00",
    //         "Remarks": "",
    //         "From Status": "8103",
    //         "From Status Desc": "MT pick-up from CY",
    //         "From Date Completed": "2023-05-17 11:54",
    //         "From Location": "17JLN",
    //         "From Area": "BC",
    //         "From Date Updated": "2023-05-17 11:54",
    //         "From UserID": "DSM003",
    //         "To Status": "8501",
    //         "To Status Desc": "Staging In",
    //         "To Date Completed": "2023-05-17 11:55",
    //         "To Location": "ABLE W/H",
    //         "To Area": "PKLG",
    //         "To Date Updated": "2023-05-17 11:55",
    //         "To UserID": "dsm",
    //         "TR Detached": "0"
    //       },
    //       {
    //         "JIAction": "D",
    //         "JINo": "JI230000134",
    //         "Consignment No": "HE0000233-001",
    //         "JourneyGUID": "4deecc65-5089-441b-a67a-7aa93eb77beb",
    //         "Movement": "DSE",
    //         "Driver No": "839",
    //         "Driver Name": "DSM003",
    //         "Driver Tel": "",
    //         "Driver IC": "111114-00-0000",
    //         "PM": "A001",
    //         "PMNo": "AAA0001",
    //         "TR": "TPC4065",
    //         "TRNo": "T/BB 4793",
    //         "B2B Consignment No": null,
    //         "B2B JourneyGUID": null,
    //         "Work Ticket Date": "2023-05-17 00:00",
    //         "Remarks": "",
    //         "From Status": "8502",
    //         "From Status Desc": "Staging Out",
    //         "From Date Completed": "2023-05-17 12:36",
    //         "From Location": "ABLE W/H",
    //         "From Area": "PKLG",
    //         "From Date Updated": "2023-05-17 12:36",
    //         "From UserID": "DSM003",
    //         "To Status": "8104",
    //         "To Status Desc": "MT delivered to shipper",
    //         "To Date Completed": "2023-05-17 14:49",
    //         "To Location": "BESTONE",
    //         "To Area": "SKS",
    //         "To Date Updated": "2023-05-17 14:49",
    //         "To UserID": "dsm",
    //         "TR Detached": "0"
    //       }
    //     ]
    //   },
    //   {
    //     "Consignment No": "HE0000233-001",
    //     "Action": "COLLECTION",
    //     "Advised Date": "2023-06-09 10:37",
    //     "RFC Doc. Rec. Date": "2023-06-09 10:37",
    //     "RFC Remarks": "[891489198] 645165196581",
    //     "Required Date": "2023-06-09 11:07",
    //     "Event Date": null,
    //     "Trips": []
    //   },
    //   {
    //     "Consignment No": "HE0000233-001",
    //     "Action": "JOB COMPLETE",
    //     "JC Driver No": "060",
    //     "JC Driver Name": "MISWAN BIN YUSOFF",
    //     "JC PM": "DSM003",
    //     "JC PMNo": "DSM003",
    //     "JC TR": "TPC4072",
    //     "JC TRNo": "T/BB 4798",
    //     "JC Date Completed": "2012-12-26 06:37",
    //     "JC Location": null,
    //     "JC Area": null,
    //     "JC Remarks": "TR BACK TO YARD",
    //     "JC Date Updated": "2012-12-26 06:43",
    //     "JC UserID": "dsm"
    //   }
    // ]
  },
  methods: {
    deliveryExpandAllBoxContainers: function() {
      let newCollapsedStates = {};

      for (const movement in this.deliveryTripsBoxContainersCollapsed) {
        newCollapsedStates[movement] = {
          "mainCollapsed": false,
          "pickupCollapsed": false,
          "dropoffCollapsed": false,
        };

        setTimeout(() => { // when all delivery boxes are expanded
          this.reupdateExpandedHeight(movement); // // reupdate expanded height for all delivery boxes after the animation finishes, just in case
        }, 300);
      }

      this.deliveryTripsBoxContainersCollapsed = newCollapsedStates;
    },
    deliveryCollapseAllBoxContainers: function() {
      let newCollapsedStates = {};

      for (const movement in this.deliveryTripsBoxContainersCollapsed) {
        newCollapsedStates[movement] = {
          "mainCollapsed": true,
          "pickupCollapsed": true,
          "dropoffCollapsed": true,
        };
      }

      this.deliveryTripsBoxContainersCollapsed = newCollapsedStates;
    },
    collectionExpandAllBoxContainers: function() {
      let newCollapsedStates = {};

      for (const movement in this.collectionTripsBoxContainersCollapsed) {
        newCollapsedStates[movement] = {
          "mainCollapsed": false,
          "pickupCollapsed": false,
          "dropoffCollapsed": false,
        };

        setTimeout(() => { // when all collection boxes are expanded
          this.reupdateExpandedHeight(movement); // // reupdate expanded height for all collection boxes after the animation finishes, just in case
        }, 300);
      }

      this.collectionTripsBoxContainersCollapsed = newCollapsedStates;
    },
    collectionCollapseAllBoxContainers: function() {
      let newCollapsedStates = {};

      for (const movement in this.collectionTripsBoxContainersCollapsed) {
        newCollapsedStates[movement] = {
          "mainCollapsed": true,
          "pickupCollapsed": true,
          "dropoffCollapsed": true,
        };
      }

      this.collectionTripsBoxContainersCollapsed = newCollapsedStates;
    },
    tripDetailsBoxContainerCollapseArrowClicked: function(collapsed, movement) {
      if (collapsed) { // if the box was collapsed
        return; // do nothing
      }

      setTimeout(() => { // if the box was expanded
        this.reupdateExpandedHeight(movement); // reupdate expanded height for all boxes in that movement after the animation finishes, just in case
      }, 300);
    },
    reupdateExpandedHeight: async function(movement) {
      if (this.$refs[`${movement}Pickup`]) { // check if it can find the vue component first,
        this.$refs[`${movement}Pickup`][0].updateExpandedHeight(); // before trying to reupdate expanded height
      }
      if (this.$refs[`${movement}Dropoff`]) {
        this.$refs[`${movement}Dropoff`][0].updateExpandedHeight();
      }
      if (this.$refs[movement]) {
        this.$refs[movement][0].updateExpandedHeight();
      }
    },
  },
  async mounted() {
    this.$bus.$on('backColorChanged', (backgroundColor) => { // getting backgroundColor from user options is asynch, therefore need to listen to an event
      this.movementDetailsCardHeaderBackgroundColor = backgroundColor; // and change the background color of the header once it has finished loading
    });
    this.movementDetailsCardHeaderBackgroundColor = this.$store.state["backgroundColor"]; // initialise background color to whatever is in vuex at the time of component mount

    const settingsSystemResult = (await this.$apiCallV2("/Master/GetSettingsSystem?settingsitem=HMS_RFC_1WayColJobs"))?.[0]?.["SettingsValue"] ?? 0;
    this.settingsSystemAllow1WayColJobRFCUpdates = settingsSystemResult === 1 || settingsSystemResult === "1";
  },
  beforeDestroy() {
    this.$bus.$off('backColorChanged'); // stop listening to the event
  },
  watch: {
    deliveryTrips: { // to handle changes made to tripDetails prop
      handler: function(newTrips) {
        let newCollapsedStates = {};

        for (const trip of newTrips) {
          newCollapsedStates[trip["Movement"]] = {
            "mainCollapsed": true,
            "pickupCollapsed": false,
            "dropoffCollapsed": false,
          };
        }

        this.deliveryTripsBoxContainersCollapsed = newCollapsedStates;
      },
      deep: true,
    },
    collectionTrips: { // to handle changes made to tripDetails prop
      handler: function(newTrips) {
        let newCollapsedStates = {};

        for (const trip of newTrips) {
          newCollapsedStates[trip["Movement"]] = {
            "mainCollapsed": true,
            "pickupCollapsed": false,
            "dropoffCollapsed": false,
          };
        }

        this.collectionTripsBoxContainersCollapsed = newCollapsedStates;
      },
      deep: true,
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.trip-details-main {

  > .content-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    > .header {
      margin-bottom: 5px;
      border-radius: 5px 5px 0 0;
      height: 30px;
      width: 100%;
      background-color: #535cda;
      padding-left: 5px;
      display: flex;
      align-items: center;

      > .title {
        color: white;
        font-weight: bold;
      }
    }

    > .movement-details-container {
      height: calc(100% - 30px);
      width: 100%;
      overflow: hidden;

      > .movement-details-card {
        margin-bottom: 10px;
        border: 1px solid black;
        border-radius: 5px;
        height: fit-content;
        width: 100%;

        &:nth-last-child(1) {
          margin-bottom: 0px;
        }

        > .header {
          border-bottom: 1px solid black;
          border-radius: 5px 5px 0 0;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          > .label {
            font-weight: bold;
          }

          > .expand-all, > .collapse-all {
            position: absolute;
            height: 20px;
            width: 20px;
            transition: 0.3s;
            cursor: pointer;

            &:hover {
              height: 40px;
              width: 40px;
            }
          }

          > .expand-all {
            right: 45px;

            &:hover {
              right: 35px;
            }
          }

          > .collapse-all {
            right: 15px;

            &:hover {
              right: 5px;
            }
          }
        }

        > .details-container {
          padding: 5px;
          display: flex;
          flex-direction: column;

          > .details-table-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            > .details-table {
              flex: 1;
              height: fit-content;

              .label, .colon, .detail {
                vertical-align: top;
                padding-bottom: 5px;
              }

              .label {
                width: 100px;
              }

              .colon {
                width: 1px;
              }

              .detail {
                word-break: break-word;
              }

              .event-date-detail {
                border-radius: 5px;
              }
            }
          }

          > .trips-list {
            display: flex;
            flex-direction: column;

            > .trip-container {
              margin-bottom: 5px;

              &:nth-last-child(1) {
                margin-bottom: 0px;
              }

              .box-container-content {
                display: flex;
                flex-direction: column;

                > .general-details-container {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;

                  > .general-details {
                    flex: 1;
                    height: fit-content;

                    .label, .colon, .detail {
                      vertical-align: top;
                    }

                    .label {
                      width: 85px;
                    }

                    #work-ticket-date-label {
                      width: 120px;
                    }

                    .colon {
                      width: 1px;
                    }

                    .detail {
                      word-break: break-word;
                    }
                  }
                }

                > .trip-statuses-container {
                  display: flex;
                  flex-direction: row;

                  > .pickup, > .dropoff {
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    .details-table {

                      .label, .colon, .detail {
                        vertical-align: top;
                      }

                      .label {
                        width: 60px;
                      }

                      .colon {
                        width: 1px;
                      }

                      .detail {
                        word-break: break-word;
                      }
                    }
                  }

                  > .pickup {
                    margin-right: 3px;
                  }

                  > .dropoff {
                    margin-left: 3px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>